"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_COUNTDOWN_COLORS = void 0;
/**
 * Default colors for the countdown component
 */
exports.DEFAULT_COUNTDOWN_COLORS = {
    BOX_COLOR: '#ffffff',
    TEXT_COLOR: '#ff0000'
};
//# sourceMappingURL=HeadingCountdown.contracts.js.map